//モーダル
$(function(){
	var scrollPos; //topからのスクロール位置
	$('.modal_open').each(function(){
			$(this).on('click',function(){
					var target = $(this).data('target');
					var modal = document.getElementById(target);

					scrollPos = $(window).scrollTop(); //topからのスクロール位置を格納
					$('body').addClass('fixed').css({ top: -scrollPos });//背景固定
					$(modal).addClass('is_open'); //is_openを追加
					return false;
			});
	});
	$('.modal_mask, .modal_close').on('click',function(){
		$('body').removeClass('fixed').css({ top: 0 }); //背景固定を解除
		$(window).scrollTop(scrollPos); //元の位置までスクロール
		$('.modal_wrapper').removeClass('is_open') //is_openを解除
			return false;
	}); 
});

//モーダル内の高さ調整
const setFillHeight = () => {
	const vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// ここからリサイズの対応
let vw = window.innerWidth;
window.addEventListener('resize', () => {
	if (vw === window.innerWidth) {
	// 画面の横幅にサイズ変動がないので処理を終える
		return;
	}
	// 画面の横幅のサイズ変動があった時のみ高さを再計算する
	vw = window.innerWidth;
	setFillHeight();
});

// 実行
setFillHeight();



// //動画再生（video）
// $(document).ready(function(){
// 	// 再生ボタンのクリックイベント
// 	$('.movie-button-play').click(function(){
// 			var videoId = $(this).data('video'); // クリックされたボタンのdata-video属性を取得
// 			if($('#' + videoId)[0].paused){
// 				setTimeout(function(){
// 						$('#' + videoId)[0].play(); // 指定されたIDのビデオを再生
// 				}, 1000); // 1秒遅延
// 			}
// 	});

// 	// 一時停止ボタンのクリックイベント
// 	$('.movie-button-pause').click(function (){
// 			var videoId = $(this).data('video'); // クリックされたボタンのdata-video属性を取得
// 			$('#' + videoId)[0].pause(); // 指定されたIDのビデオを一時停止
// 	});
// });


// YouTube APIの読み込み
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


//動画再生（youtube）
var players = {};

// YouTube Iframe APIが準備完了後に呼ばれる関数
function onYouTubeIframeAPIReady() {
  // プレーヤーを作成して、playersオブジェクトに格納
  players['video1'] = new YT.Player('video1', {
    events: {
      'onReady': function(event) {
        event.target.mute(); // ミュートに設定
      }
    }
  });
  
  players['video2'] = new YT.Player('video2', {
    events: {
      'onReady': function(event) {
        event.target.mute(); // ミュートに設定
      }
    }
  });

  players['video3'] = new YT.Player('video3', {
    events: {
      'onReady': function(event) {
        event.target.mute(); // ミュートに設定
      }
    }
  });

  console.log('YouTube API is ready');
}

// 再生ボタンのクリックイベント
$('.movie-button-play').click(function() {
  var videoId = $(this).data('video'); // クリックされたボタンのdata-video属性を取得
  if (players[videoId] && players[videoId].getPlayerState() !== YT.PlayerState.PLAYING) {
    setTimeout(function() {
      players[videoId].playVideo(); // 該当のプレーヤーで動画を再生
    }, 1000); // 1秒遅延
  }
});

// 一時停止ボタンのクリックイベント
$('.movie-button-pause').click(function() {
  var videoId = $(this).data('video'); // クリックされたボタンのdata-video属性を取得
  if (players[videoId] && players[videoId].getPlayerState() === YT.PlayerState.PLAYING) {
    players[videoId].pauseVideo(); // 該当のプレーヤーで動画を一時停止
  }
});